// extracted by mini-css-extract-plugin
export default {"secureText":"styles_secureText__LggCu"};